export default __webpack_public_path__ + "static/media/p15.35c3bc3c.jpg";